const useExport = ({ dispatch, onExport }) => {
  const onExportEnd = (exportType, status = {}) => {
    dispatch({
      type: 'UPDATE_STATE',
      key: 'export',
      state: {
        failed: status.failed ? { exportType } : null,
        processing: null
      }
    })
  }

  const onExportStart = (exportType, params) => {
    dispatch({
      type: 'UPDATE_STATE',
      key: 'export',
      state: {
        failed: null,
        processing: exportType
      }
    })

    onExport(params, (status = {}) => onExportEnd(exportType, status))
  }

  return { onExportStart }
}

export default useExport
